export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpy3ngeHBciOImZmflgiGRiycD92hu_5xcSQ&usqp=CAU";

export const MENU_URL = "/api/swiggy-proxy?path=dapi/menu/pl";

export const ExploreRestaurants_URL =
  "/api/swiggy-proxy?path=dapi/restaurants/list/v5";

export const ITEM_IMG_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/";

export const EXPLORE_IMG_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/";
